import { KirokuLoading } from '../../../ui';
import React             from 'react';

const LoadingComponent = () => {
    return <div style={{height: '100vh'}}>
        <KirokuLoading />
    </div>
}
export default LoadingComponent;
